import t from "react";
function o() {
  if (typeof window > "u")
    return {
      width: 0,
      height: 0
    };
  const { innerWidth: e, innerHeight: i } = window;
  return {
    width: e,
    height: i
  };
}
function s() {
  const [e, i] = t.useState(o());
  return t.useEffect(() => {
    function n() {
      i(o());
    }
    return e.width === void 0 && e.height === void 0 && n(), window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, [e.height, e.width]), e;
}
export {
  s as u
};
